import { ReactNode, useEffect } from "react";
import { Box, CssBaseline, Backdrop, Typography } from "@mui/material";
// import { ChatWidget } from "components/ui/chatWidget";
//import { useLocalStorage } from "hooks/useLocalStorage";
import { useUiStore } from "hooks/useUiStore";
import { Outlet } from "react-router-dom";
import { Footer } from "./footer";
import { Navbar } from "./navbar";
import { Sidenav } from "./sidenav";
// import { Detector } from "react-detect-offline";
/* import { Offline } from "./components/offline"; */
import { ModalWhats } from "components/modalWhats/ModalWhats";
import { Loading2 } from "components/ui/loading2";
import { useAuthStore } from "hooks/useAuthStore";
import { ModalEncuesta } from "components/modalEncuesta/ModalEncuesta";
import { useEncuestaCalidad } from "hooks/encuestas/encuestaCalidad";
/* import { Detector } from "react-detect-offline"; */

interface PropsInterface {
  children: ReactNode;
}

const drawerWidth = 280;
export const AdminLayout = ({ children }: PropsInterface) => {
  const { openDrawer, handleOpenDrawer } = useUiStore();
  const { isLoading, messageLoading } = useUiStore();
  const { startGetImagenPerfil } = useAuthStore();
  const { user, isEncuestaOpen, isActiva, startGetVerificacion } =
    useEncuestaCalidad();

  useEffect(() => {
    if (user && user.session && user.session.cveUsuario !== undefined) {
      startGetVerificacion(6, user?.session?.cveUsuario);
    }
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    handleOpenDrawer(true);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    startGetImagenPerfil();
    // eslint-disable-next-line
  }, []);

  return (
    <Box>
      <CssBaseline />
      <Sidenav />
      <Navbar />
      {isActiva ? <ModalEncuesta /> : null}
      {isActiva === false || (isActiva && isEncuestaOpen === false) ? (
        <ModalWhats />
      ) : null}
      <Box
        component="main"
        sx={{
          width: {
            xl: openDrawer ? `calc(100% - ${drawerWidth}px)` : "100",
            lg: openDrawer ? `calc(100% - ${drawerWidth}px)` : "100",
          },
          ml: {
            xl: openDrawer ? `${drawerWidth}px` : "100",
            lg: openDrawer ? `${drawerWidth}px` : "100",
            md: openDrawer ? `${drawerWidth}px` : "100",
            sm: "100",
            xs: "100",
          },
          mt: "3.5rem",
          flexGrow: 1,
          p: 3,
        }}
      >
        {children}
        {/* <ChatWidget /> */}
        <Outlet />
        {/* <Detector render={({ online }) => <Offline online={online} />} /> */}
        <Backdrop sx={{ color: "#fff", zIndex: 99999999999 }} open={isLoading}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {messageLoading ? (
              <Box className="w-full flex justify-center items-end">
                <Typography
                  variant="h5"
                  className="loading"
                  sx={{ zIndex: 99999999 }}
                >
                  {messageLoading}
                </Typography>
              </Box>
            ) : (
              <Loading2 showText={true} />
            )}
          </Box>
        </Backdrop>
      </Box>
      {/* <div className="confia">
        {" "}
        <Footer />
      </div> */}
    </Box>
  );
};
